const tenancies = (tenancies = [], action) => {
  switch (action.type) {
    case 'FETCH_TENANCIES':
      return action.payload
    default:
      return tenancies
  }
}
export default tenancies
